import {
  IonTabBar,
  IonTabButton,
  IonLabel,
  IonIcon,
  IonRouterOutlet,
} from '@ionic/react'
import { home, carSport } from 'ionicons/icons'
import { ReactNode, useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { DEFAULT_REGION_OPTION } from '~/shared/config/constants'
import { pushFx } from '~/shared/lib/history'
import { filterHelpers } from '~/shared/ui/ScrollableList'
import { IonTabs } from './styled'

type TabsLayoutProps = {
  children?: ReactNode
}

export function MinimalTabsLayout({ children }: TabsLayoutProps) {
  const location = useLocation()

  useEffect(() => {
    const handleClick = (event: Event) => {
      const target = event.target as HTMLElement
      const ionTabButton = target.closest('ion-tab-button')
      if (ionTabButton) {
        const tabKey = ionTabButton.getAttribute('tab')

        if (tabKey === 'booking-cars') {
          const regionFilter = `regionCode=${filterHelpers.encodeOption(
            DEFAULT_REGION_OPTION,
          )}`
          pushFx(`/${tabKey}?${regionFilter}`)
        } else {
          pushFx(`/${tabKey}`)
        }

        event.stopImmediatePropagation()
      }
    }

    document.addEventListener('click', handleClick, true)

    return () => {
      document.removeEventListener('click', handleClick, true)
    }
  }, [])

  const isLoginActive = location.pathname === '/login'
  const isBookingCarsActive = location.pathname.startsWith('/booking-cars')

  return (
    <IonTabs>
      <IonRouterOutlet>{children || <Outlet />}</IonRouterOutlet>
      <IonTabBar slot='bottom'>
        <IonTabButton tab='booking-cars' selected={isBookingCarsActive}>
          <IonIcon icon={carSport} />
          <IonLabel>Аренда авто</IonLabel>
        </IonTabButton>
        <IonTabButton tab='login' selected={isLoginActive}>
          <IonIcon icon={home} />
          <IonLabel>Вход</IonLabel>
        </IonTabButton>
      </IonTabBar>
    </IonTabs>
  )
}
